<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingJournalsWorkspace from '@/views/Banking/Journals/BankingJournalsWorkspace.vue'

definePage({
  meta: { ...PageMeta.Banking.Journals.Meta, pageTitle: PageMeta.Banking.Journals.Title },
})
</script>

<template>
  <BankingJournalsWorkspace />
</template>
